import { RowCrudStatus } from "../../common/types";
import {
  PaymentReceiptType,
  PaymentReceiptTypeCreateMutationVariables,
  PaymentReceiptTypeUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { currencyDisplayId } from "../../currency/store/CurrencyCommonStore";

export type PaymentReceiptTypeValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name_es: string;
  name_en: string;
  name_pt: string;
  price: number;
  __currency: string;
  showCurrency: { displayId: string; id: string } | null;
};

export type PaymentReceiptTypeErrorsType = {
  name_es?: { message: string; fieldLabel: string };
  name_en?: { message: string; fieldLabel: string };
  name_pt?: { message: string; fieldLabel: string };
  price?: { message: string; fieldLabel: string };
  currency?: { message: string; fieldLabel: string };
};

export function PaymentReceiptTypeValuesInit(): PaymentReceiptTypeValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name_es: "",
    name_en: "",
    name_pt: "",
    price: 0,
    __currency: "",
    showCurrency: null,
  };
}

export type PaymentReceiptTypeType =
  | PaymentReceiptType
  | PaymentReceiptTypeValuesType;

export function paymentReceiptTypeDisplayId(
  source: Partial<PaymentReceiptType>,
  _langStore: LangStore
) {
  return `${
    source[_langStore.fieldByLang("name") as keyof PaymentReceiptTypeType]
  }`;
}

export function getPaymentReceiptTypeValues(
  source: PaymentReceiptTypeType,
  _langStore: LangStore,
  _duplicated: boolean = false
): PaymentReceiptTypeValuesType {
  const entityValues = PaymentReceiptTypeValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : paymentReceiptTypeDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name_es = source.name_es;
  entityValues.name_en = source.name_en;
  entityValues.name_pt = source.name_pt;
  entityValues.price = Number(source.price) || 0;
  entityValues.showCurrency =
    "currency" in source && source.currency
      ? {
          id: source.currency.id,
          displayId: currencyDisplayId(source.currency, _langStore),
        }
      : "showCurrency" in source && source.showCurrency
      ? { id: source.showCurrency.id, displayId: source.showCurrency.displayId }
      : null;
  entityValues.__currency = entityValues.showCurrency?.displayId || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getPaymentReceiptTypeUpdateVariables(
  values: PaymentReceiptTypeValuesType
): PaymentReceiptTypeUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
    price: values.price,
    currencyId: values.showCurrency?.id || "",
  };
}

export function getPaymentReceiptTypeCreateVariables(
  values: PaymentReceiptTypeValuesType
): PaymentReceiptTypeCreateMutationVariables {
  return {
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
    price: values.price,
    currencyId: values.showCurrency?.id || "",
  };
}
